export const UPDATE_PAGE = "UPDATE_PAGE";